import { COMPANY_NAME, COMPANY_REGION, COMPANY_SHORT, COMPANY_LOCATION, PROFILE_FACTS } from '../constants';

function HeroSection() {
  return (
    <section className="relative overflow-hidden bg-blueprint bg-grid-32 text-paper">
      <div className="mx-auto grid max-w-6xl gap-10 px-6 py-20 lg:grid-cols-[1.08fr_0.92fr] lg:items-center lg:py-28">
        <div>
          <span className="inline-flex items-center gap-2 rounded-pill border border-paper/20 bg-paper/10 px-4 py-1.5 text-xs font-black uppercase tracking-[0.22em] text-mint">
            <span className="h-2 w-2 rounded-full bg-signal" />
            Public company profile / {COMPANY_REGION}
          </span>
          <h1 className="mt-7 max-w-3xl text-5xl font-black uppercase leading-[0.96] tracking-normal text-paper sm:text-6xl lg:text-7xl">
            {COMPANY_NAME}
          </h1>
          <p className="mt-7 max-w-2xl text-lg leading-8 text-paper/75">
            A crisp public-facing profile for {COMPANY_SHORT}, organized from its California LLC filing and anchored in {COMPANY_LOCATION}.
          </p>
          <div className="mt-9 flex flex-col gap-3 sm:flex-row">
            <a
              href="#about"
              className="rounded-pill bg-signal px-7 py-3.5 text-center font-black text-midnight shadow-soft transition hover:bg-mint"
            >
              View profile
            </a>
            <a
              href="#visit"
              className="rounded-pill border border-paper/25 bg-paper/10 px-7 py-3.5 text-center font-semibold text-paper transition hover:bg-paper/20"
            >
              Principal office
            </a>
          </div>
        </div>

        <div className="rounded-[1.5rem] border border-paper/20 bg-paper/10 p-5 shadow-soft backdrop-blur">
          <div className="rounded-2xl border border-paper/10 bg-midnight/70 p-5">
            <div className="flex items-center justify-between border-b border-paper/10 pb-4">
              <p className="text-xs font-black uppercase tracking-[0.22em] text-signal">Formation Snapshot</p>
              <p className="rounded-pill bg-mint px-3 py-1 text-xs font-black text-midnight">Active profile</p>
            </div>
            <div className="mt-5 grid gap-4">
              {PROFILE_FACTS.map((fact) => (
                <div key={fact.label} className="grid grid-cols-[6.5rem_1fr] gap-4 rounded-xl bg-paper/10 p-4">
                  <p className="text-[11px] font-black uppercase tracking-[0.18em] text-paper/50">
                    {fact.label}
                  </p>
                  <p className="font-semibold leading-6 text-paper">{fact.value}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
